var _dec, _class, _FormFieldMessages;
/*
 * The MIT License (MIT)
 *
 * Copyright (c) 2015 - present Instructure, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */

import { Component } from 'react';
import { omitProps } from '@instructure/ui-react-utils';
import { withStyle } from '@instructure/emotion';
import { FormFieldMessage } from "../FormFieldMessage/index.js";
import generateStyle from "./styles.js";
import generateComponentTheme from "./theme.js";
import { allowedProps } from "./props.js";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
/**
---
parent: FormField
---

A FormFieldMessages component

```js
---
type: example
---
<FormFieldMessages messages={[
  { text: 'Invalid name', type: 'error' },
  { text: 'Good job!', type: 'success' },
  { text: 'Full name, first and last', type: 'hint' },
]} />
```
**/
let FormFieldMessages = (_dec = withStyle(generateStyle, generateComponentTheme), _dec(_class = (_FormFieldMessages = class FormFieldMessages extends Component {
  constructor(...args) {
    super(...args);
    this.ref = null;
    this.handleRef = el => {
      this.ref = el;
    };
  }
  componentDidMount() {
    var _this$props$makeStyle, _this$props;
    (_this$props$makeStyle = (_this$props = this.props).makeStyles) === null || _this$props$makeStyle === void 0 ? void 0 : _this$props$makeStyle.call(_this$props);
  }
  componentDidUpdate() {
    var _this$props$makeStyle2, _this$props2;
    (_this$props$makeStyle2 = (_this$props2 = this.props).makeStyles) === null || _this$props$makeStyle2 === void 0 ? void 0 : _this$props$makeStyle2.call(_this$props2);
  }
  render() {
    const _this$props3 = this.props,
      messages = _this$props3.messages,
      styles = _this$props3.styles;
    return messages && messages.length > 0 ? _jsx("div", {
      css: styles === null || styles === void 0 ? void 0 : styles.formFieldMessages,
      ...omitProps(this.props, FormFieldMessages.allowedProps),
      ref: this.handleRef,
      children: messages.map((msg, i) => {
        return _jsx("span", {
          css: styles === null || styles === void 0 ? void 0 : styles.message,
          children: _jsx(FormFieldMessage, {
            variant: msg.type,
            children: msg.text
          })
        }, `error${i}`);
      })
    }) : null;
  }
}, _FormFieldMessages.displayName = "FormFieldMessages", _FormFieldMessages.componentId = 'FormFieldMessages', _FormFieldMessages.allowedProps = allowedProps, _FormFieldMessages.defaultProps = {}, _FormFieldMessages)) || _class);
export default FormFieldMessages;
export { FormFieldMessages };